import { ApiService } from '@services/ApiService'
import { BaseStore } from '@stores/baseStore'
import { action } from 'mobx'

const defaultState = {}

class Store extends BaseStore {
  constructor() {
    super()

    this.initStore(defaultState, {
      fetchData: action,
    })
  }

  fetchData = async params => {
    try {
      const res = await ApiService.AppointmentSession.DaySheetPrint(params)
      return res.data
    } catch (error) {
      throw error
    }
  }
}

export default new Store()
